import apiClient from './apiClient';

const API_URL = '/medicos';

// 🔹 Crear médico
export const crearMedico = async (medico) => {
    const response = await apiClient.post(API_URL, medico);
    return response.data;
};

// 🔹 Listar todos los médicos (opcionalmente filtrando por activo o texto)
export const listarMedicos = async (activo = null, filtro = null) => {
    let url = API_URL;
    const params = [];

    if (activo !== null) params.push(`activo=${activo}`);
    if (filtro) params.push(`filtro=${encodeURIComponent(filtro)}`);

    if (params.length > 0) url += `?${params.join('&')}`;

    const response = await apiClient.get(url);
    return response.data;
};

// 🔹 Obtener médico por ID
export const obtenerMedicoPorId = async (idMedico) => {
    const response = await apiClient.get(`${API_URL}/${idMedico}`);
    return response.data;
};

// 🔹 Actualizar médico
export const actualizarMedico = async (idMedico, medicoActualizado) => {
    const response = await apiClient.put(`${API_URL}/${idMedico}`, medicoActualizado);
    return response.data;
};

// 🔹 Eliminar médico (borrado físico)
export const eliminarMedico = async (idMedico) => {
    const response = await apiClient.delete(`${API_URL}/${idMedico}`);
    return response.data;
};

// 🔹 Inactivar médico (baja lógica)
export const inactivarMedico = async (idMedico) => {
    const response = await apiClient.patch(`${API_URL}/${idMedico}/inactivar`);
    return response.data;
};

// 🔹 Reactivar médico
export const reactivarMedico = async (idMedico) => {
    const response = await apiClient.patch(`${API_URL}/${idMedico}/reactivar`);
    return response.data;
};
